<template>
  <div class="page_custom_test--cp_request_test">
    <Popup ref="edit_popup">
      <EditTestConfigModal @dataChanged="fetchData" :mode="mode" :whitelist="whitelist"/>
    </Popup>
    <div class="url">
      <el-switch
        v-model="mode"
        active-text="Conf"
        inactive-text="Req"
        style="margin-right: 5px;"
        @change="modeChanged"
      />
      <el-input v-model="config.url" @input="modifyUrl" placeholder="url" :disabled="connected"></el-input>
      <el-button @click="connectOrDisconnect" :type="connected ? 'danger' : 'primary'">
        {{ connected ? $t("button.disconnect") : $t("button.connect") }}
      </el-button>
    </div>
    <div class="setting">
      <el-checkbox v-model="immediate"
                   :disabled="mode"
      >{{ $t("label.immediate") }}</el-checkbox>
    </div>
    <div class="content">
      <div class="display">
        <div class="send-wrapper">
          <!-- <div class="label">Send</div> -->
          <div class="actions">
            <div class="action" v-for="type in Object.keys(template)" :key="type">
              <el-button @click="send(type)" :disabled="!connected">{{ type }}</el-button>
            </div>
          </div>
        </div>
        <div class="receive-wrapper">
          <!-- <div class="label">Received</div> -->
          <div class="chat-content">
            <div class="action-btn">
              <el-button icon="el-icon-s-tools" type="info" size="mini" @click="openEdit"></el-button>
              <el-button class="clear-btn" size="mini" v-show="messages.length > 0" @click="clearMessage" type="info">Clear</el-button>
            </div>
            <div class="row" :class="msg.type" v-for="(msg,index) in messages" :key="index">
              <div class="inner-wrap">
                <div class="message" :contenteditable="!mode && msg.type=='send' && !msg.sent" @input="inlineUpdateMessage($event,index)" v-html="msg.message" v-once></div>
                <div class="meta">
                  <div class="sent-mask" v-if="msg.sent"></div>
                  <div class="send" @click="actualSend(index)" v-if="!msg.sent && msg.type=='send' && !mode">{{ $t("button.send") }}</div>
                  <div class="gap"></div>
                  <div class="datetime" :title="$moment(msg.timestamp, 'x').format('YYYY-MM-DD HH:mm:ss.SSS')">{{ msg.timestamp ? $moment(msg.timestamp, 'x').format("HH:mm:ss") : "---" }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateInitialData from "@/utils/cp_req_init_data";
import ConfTemplateInitData from "@/utils/cp_conf_init_data";
import EditTestConfigModal from "../modules/EditTestConfigModal";

export default {
  props: {
    whitelist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    EditTestConfigModal
  },
  beforeMount() {
    this.fetchData();
  },
  mounted() {
    let el = document.querySelector(".chat-content");
    el.style = `height: ${el.clientHeight}px`;
  },
  methods: {
    initData() {
      if(typeof localStorage.request_template == "undefined") {
        localStorage.request_template = JSON.stringify(TemplateInitialData);
      }
      if(typeof localStorage.conf_template == "undefined") {
        localStorage.conf_template = JSON.stringify(ConfTemplateInitData);
      }
      if(typeof localStorage.request_test_config == "undefined") {
        localStorage.request_test_config = JSON.stringify({
          url: "ws://localhost:8080/ocpp/FOR_TEST_PURPOSE",
        });
      }
    },
    fetchData() {
      let version = "2";
      if(typeof localStorage.lms_version == "undefined" || localStorage.lms_version != version) {
        localStorage.lms_version = version;
        localStorage.request_template = JSON.stringify(TemplateInitialData);
        localStorage.conf_template = JSON.stringify(ConfTemplateInitData);
        localStorage.request_test_config = JSON.stringify({
          url: "ws://localhost:8080/ocpp/FOR_TEST_PURPOSE",
        });
        this.initData();
      }
      console.log(this.mode);
      if(this.mode) {
        this.template = JSON.parse(localStorage.conf_template);

        console.log(this.template)
      }else {
        this.template = JSON.parse(localStorage.request_template);
        // if(this.whitelist.length > 0) {
          let obj = {};
          Object.keys(this.template).map(key=>{
            // if(this.whitelist.includes(key)) {
              obj[key] = this.template[key];
            // }
          });
          this.template = obj;
        // }
      }
      this.config = JSON.parse(localStorage.request_test_config);
    },
    connectOrDisconnect() {
      if(this.connected) {
        this.connection.close();
        this.connection = false;
        return;
      }
      let vm = this;
      try{
        this.connection = new WebSocket(this.config.url, "ocpp1.6");
      }catch(err) {
        this.$notify.error({
          title: 'Error',
          message: 'Websocket Connection Error',
          position: 'top-left'
        });
      }
      this.connection.onopen = function (event) {
        let regexp = /.+\/(.+)$/.exec(vm.config.url);
        console.log("opened");
        vm.connected = true;
        if(regexp.length > 1) {
          document.title = `🔴 ${regexp[1]}`;
        }
      };
      this.connection.onmessage = function (event) {
        console.log(event.data);
        vm.output += "\n=\n" + event.data;
        vm.messages.push({
          type: "receive",
          timestamp: vm.$moment().format('x'),
          message: event.data
        });
        if(vm.mode && vm.immediate) {
          vm.autoReply(event.data);
        }
        setTimeout(()=>{
          let el = document.querySelector(".chat-content > .row:last-child");
          el.scrollIntoView({behavior: "smooth", block: "end"});
        }, 50);
      }
      this.connection.onclose = function (event) {
        console.log("closed");
        vm.connected = false;
        let regexp = /.+\/(.+)$/.exec(vm.config.url);
        if(regexp.length > 1) {
          document.title = `⚪ ${regexp[1]}`;
        }
      }
      this.connection.onerror = function (event) {
        vm.$notify.error({
          title: 'Error',
          message: 'Websocket Error',
          position: 'top-left'
        });
        // vm.connected = false;
      }
    },
    send(code) {
      let msgSet = this.template[code].data;
      msgSet.map(msg=>{
        let received_msgs = this.messages.filter(m=>m.type=="receive");
        let last_received_msg = received_msgs.length > 0 ? JSON.parse(received_msgs[received_msgs.length-1].message) : undefined;
        console.log("received_msgs: ",received_msgs);
        console.log("last_received_msg: ",last_received_msg);
        msg[1] = last_received_msg ? last_received_msg[1] : 1;
        if(this.mode || this.immediate) {
          this.connection.send(JSON.stringify(msg));
        }
        this.messages.push({
          type: "send",
          sent: this.immediate,
          timestamp: this.$moment().format('x'),
          message: JSON.stringify(msg)
        });
        setTimeout(()=>{
          let el = document.querySelector(".chat-content > .row:last-child");
          el.scrollIntoView({behavior: "smooth", block: "end"});
        }, 50);
      });
    },
    actualSend(index) {
      console.log("actual send");
      let msg = this.messages[index];
      msg.sent = true;
      console.log(msg);
      this.connection.send(msg.message);
    },
    autoReply(msg) {
      let json = JSON.parse(msg);
      this.send(json[2]);
    },
    msgBoxScrollToBottom() {
      // el.scrollTop = el.scrollHeight;
      let row = document.querySelector(".chat-content > .row:last-child");
      row.scrollIntoView(false);
    },
    clearMessage() {
      this.messages = [];
    },
    openEdit() {
      this.$refs.edit_popup.show();
    },
    modifyUrl(value) {
      let config = JSON.parse(localStorage.request_test_config);
      config.url = value;
      localStorage.request_test_config = JSON.stringify(config);
    },
    modeChanged(mode) {
      this.fetchData();
    },
    inlineUpdateMessage(e,index) {
      console.log(e.target);
      this.messages[index].message = e.target.innerHTML;
    }
  },
  beforeDestroy() {
    this.connection.close();
  },
  data() {
    return {
      mode: false,
      config: {
        url: "ws://localhost:8080/ocpp/FOR_TEST_PURPOSE",
      },
      input: "",
      output: "",
      messages: [],
      template: {},

      connection: {},
      connected: false,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.page_custom_test--cp_request_test{
  display: flex;
  flex-direction: column;
  .url{
    display: flex;
    align-items: center;
    button{
      width: 170px;
      margin-left: 5px;
    }
  }
  .content{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    .actions{
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 5px;
      margin: 10px 0px;
      .action{
        display: flex;
        button{
          flex-grow: 1;
          padding: 12px 10px;
        }
      }
    }
    .display{
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      .send-wrapper,
      .receive-wrapper{
        // flex-grow: 1;
        display: flex;
        flex-direction: column;
        .el-textarea{
          // height: 100%;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          textarea{
            flex-grow: 1;
          }
        }
      }

      .row{
        display: flex;
        margin: 2px;
        &.send{
          justify-content: flex-end;
        }
        &.receive{
          justify-content: flex-start;
        }
      }
      .message{
        max-width: 500px;
        padding: 5px 10px;
        word-break: break-all;
        background: #e1e1e1;
        border-radius: 5px;
      }
      .send-wrapper{
        // flex-grow: 1;
      }
      .receive-wrapper{
        flex-grow: 5;
        position: relative;
        .chat-content{
          display: flex;
          flex-direction: column;
          overflow: auto;
          // flex-flow: column-reverse;
          flex-grow: 1;
          // justify-items: flex-end;
          .action-btn{
            z-index: 1;
            position: absolute;
            top: 0;
            left: 0;
            button{
              opacity: .3;
              transition: opacity .2s ease-in-out;
              &:hover{
                opacity: 1;
              }
            }
          }
          .clear-btn{
            
          }
          .inner-wrap{
            position: relative;
            .message{
              font-size: 14px;
            }
            .meta{
              display: flex;
              justify-content: space-between;
              font-size: 10px;
              color: #999;
              
              .sent-mask{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                right: 0;
                right: 0;
                z-index: 1;
              }
              .send{
                user-select: none;
                cursor: pointer;
              }
              // .datetime{
              //   text-align: right;
              // }
            }
          }
        }
      }
    }
  }
}
</style>